module.exports = __webpack_public_path__ + "img/multiplier_8.7a69d0f9.png";